import React from "react";
import { Link } from "react-router-dom";
import { Gift } from "lucide-react";

// Slim launch-offer ribbon shown at the top of public pages.
export const PromoBanner = () => (
    <Link
        to="/register"
        data-testid="promo-banner"
        className="block bg-accent text-accent-foreground transition-colors hover:bg-accent/90"
    >
        <div className="mx-auto flex max-w-6xl items-center justify-center gap-2 px-5 py-2 text-center text-sm font-600">
            <Gift className="h-4 w-4 shrink-0" />
            <span>
                <span className="font-700">First month FREE</span> — cancel anytime.{" "}
                <span className="underline underline-offset-2">Join the Club →</span>
            </span>
        </div>
    </Link>
);

export default PromoBanner;
